<template>
    <div class="container"> 
        <div class="dialog" v-click-outside="cancelCallback">
            <div class="title">
                {{title}}
            </div>
            <div class="content">
                {{text}}
            </div>
            <div class="buttonContainer">
                <button @click="cancelCallback">Cancel</button>
                <button @click="successCallback">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
import clickOutside from '@/directives/clickOutside'
export default {
    directives: {
        clickOutside
    },
    props: {
        title: {
            type: String,
            default: 'Title'
        },
        text: {
            type: String,
            default: 'Text'
        },
        successCallback: {
            type: Function,
            default: () => {}
        },
        cancelCallback: {
            type: Function,
            default: () => {}
        }
    }
}
</script>

<style scoped>
.container{
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%; 
    min-width: max-content;
    min-height: max-content;
    background: rgba(0, 0, 0, .3); 
    z-index: 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.dialog{
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    width: 250px;
    box-sizing: content-box;
    padding: 10px 20px;
    background: #fff;
}

.title{
    font-weight: 600;
    display: flex; justify-content: flex-start; align-items: center; 
    border-radius: 5px 5px 0 0; font-size: 16px; color: #000;
    padding: 10px 0;
}

.content{
    display: flex; justify-content: flex-start; align-items: center; 
    border-radius: 0 ; gap: 5px; color: #333; font-size: 14px;
    padding: 20px 0;
}

.buttonContainer{
    padding: 10px 0;
    display: flex; justify-content: flex-end; align-items: center; 
    border-radius: 0 0 5px 5px;
    gap: 10px;
}

.buttonContainer button{
    width: max-content;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    border: none;
    color: #333;
    cursor: pointer;
    outline: none;
    font-size: 14px;
}

.buttonContainer button:hover{
    text-decoration: underline #333;
}
</style>